import React, { useCallback } from 'react';
import Header from 'src/routes/Layout/Header';
import { Container } from 'src/routes/Layout/Page/styles';
import vaccinationService from 'src/service/vaccinationService';
import { Content, LocalHeader, Title } from '../ReservationReport/styles';
import Toast from 'src/components/Toast';
import DataGrid from './components/DataGrid';
import usePaginationObservable from 'src/hooks/usePagination';
import Refresh from '../ReservationReport/components/Refresh';
import Filters from './components/Filters';

const Vaccination = () => {
  const [params, mergeParams, loading, data, error, , refresh] = usePaginationObservable(
    params => vaccinationService.getAll(params),
    {},
    []
  );

  const toast = Toast();

  const handleRefresh = useCallback(async () => {
    try {
      refresh();
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  }, [refresh]);

  const handleAccept = useCallback(
    (ids: number[]) => {
      vaccinationService
        .accept({ ids })
        .then(() => {
          toast.success('A(s) vacinações(s) foi(foram) aceita(s) com sucesso!');
          refresh();
        })
        .catch(err => {
          const {
            response: { data }
          } = err;
          let messageValue = '';

          // if (typeof messages[data.message] === 'function') messageValue = messages[data.message](data.value);
          // else messageValue = messages[data.message];

          if (data.message === 'reservation-has-already-accept') refresh();

          toast.error(messageValue);
        });
    },
    [refresh, toast]
  );

  const handleCancel = useCallback(
    (ids: number[]) => {
      vaccinationService
        .cancel({ ids })
        .then(() => {
          toast.success('A(s) vacinações(s) foi(foram) cancelada(s) com sucesso!');
          refresh();
        })
        .catch(err => {
          const {
            response: { data }
          } = err;
          let messageValue = '';

          // if (typeof messages[data.message] === 'function') messageValue = messages[data.message](data.value);
          // else messageValue = messages[data.message];

          if (data.message === 'reservation-has-already-canceled') refresh();

          toast.error(messageValue);
        });
    },
    [refresh, toast]
  );

  return (
    <Container>
      <Header />
      <Content>
        <LocalHeader>
          <Title>Vacinação</Title>
          <Refresh onClick={handleRefresh} loading={loading} />
        </LocalHeader>
        <Filters params={params} mergeParams={mergeParams} />
        <DataGrid
          params={params}
          mergeParams={mergeParams}
          checkbox={true}
          loading={loading}
          error={error}
          data={data}
          onCancel={handleCancel}
          onAccept={handleAccept}
        />
      </Content>
    </Container>
  );
};

export default Vaccination;
